import styled, { css } from "styled-components";
import colors from "../../../constants/colors";

const sizes = {
  small: "1.5rem",
  medium: "2.5rem",
  large: "4rem",
};

// Teal/cyan gradient for insights - data-driven and modern
const TRENDING_GRADIENT = "linear-gradient(135deg, #06B6D4 0%, #0891B2 100%)";
const TRENDING_COLOR = "#06B6D4";

export const TrendingUpIconWrapper = styled.div<{
  $size: "small" | "medium" | "large";
  $withGlow: boolean;
  $customStyle: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .MuiSvgIcon-root {
    font-size: ${({ $size }) => sizes[$size]};
    transition: all 0.3s ease;

    ${({ $customStyle, $size }) =>
      $customStyle
        ? $size === "small"
          ? css`
              /* Small icons: solid color for better legibility on mobile */
              color: ${TRENDING_COLOR};
            `
          : css`
              /* Medium/Large icons: full gradient treatment */
              background: ${TRENDING_GRADIENT};
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            `
        : css`
            color: ${colors.BLACK};
          `}

    ${({ $withGlow, $customStyle }) =>
      $withGlow && $customStyle
        ? css`
            filter: drop-shadow(0 2px 8px rgba(6, 182, 212, 0.4));
          `
        : ""}
  }
`;
